import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const Container = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  color: active ? theme.palette.primary.main : theme.palette.grey.A100,
  padding: theme.spacing(7, 0),
  userSelect: 'none',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const ActiveStrip = styled('div', {
  shouldForwardProp: (props) => props !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  width: 3,
  backgroundColor: active ? theme.palette.primary.main : 'transparent',
  borderRadius: '0px 100px 100px 0px',
}));
